module.exports = __webpack_public_path__ + "static/media/fvd.e179ca08.gif";